import styled from "@emotion/styled";
import { colorPalette } from "../../theme/colors";
import { TagType } from "./Tags.types";
import { generateTagStyles } from "../../utils";
import { getColor } from "../../theme/theme";
import { ThemeMode } from "../../theme/theme.types";

// Ensure inline display for tags
// export const TagContainer = styled.span<{ type: string }>`
//   display: inline-flex;
//   padding: ${({ type }) => tagStyles[type]?.padding || "2px"};
//   justify-content: center;
//   align-items: center;
//   border-radius: ${({ type }) => tagStyles[type]?.borderRadius || "2px"};
//   background-color: ${({ type }) => tagStyles[type]?.background || "#e0e0e0"};
//   color: ${({ type }) => tagStyles[type]?.textColor || "#000"};
//   gap: 4px;
//   white-space: nowrap;
// `;
interface StyledTagProps {
  type: TagType;
  backgroundColor?: string;
  color?: string;
  theme?: { mode?: ThemeMode };
}

export const TagContainer = styled.span<StyledTagProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  white-space: nowrap;
  cursor: pointer;
  ${(props) =>
    props.backgroundColor &&
    `background-color: ${getColor(
      props.backgroundColor,
      props.theme?.mode
    )} !important;`}

  ${(props) =>
    props.color &&
    `color: ${getColor(props.color, props.theme?.mode)} !important;`}
    ${(props) => generateTagStyles({ type: props.type })};
  ${(props) =>
    props.type === "track" &&
    `
    border: 1px solid ${getColor(
      props.backgroundColor || "",
      props.theme?.mode
    )};
  `}
`;

// Ensure the icon is in a row
export const IconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
`;

export const Icon = styled.i<{ iconColor?: string }>`
  color: ${({ iconColor }) => iconColor || colorPalette.popWhite[500]};
  font-size: 11px;
  line-height: 17px;
  letter-spacing: 0.2px;
`;
